<template>
  <div class="popup-card">
    <h3 class="popup-card__header">
      <slot name="card-header" />
    </h3>
    <slot />
  </div>  
</template>

<script>
export default {
  name: "BasePopUpCard"

}
</script>

<style>
  .popup-card {
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 25px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgb(15 32 47 / 50%);
  }

  .popup-card__header {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 10px;
    margin-top: 10px;
    text-align: left;
    padding: 0;
  }

</style>